const calculatePercentIncome = (totalIncome, totalPerCategory) => {
  const sumTotalIncome = totalIncome.reduce((acc, val) => acc + val, 0);

  if (sumTotalIncome === 0 || totalPerCategory.length === 0) {
    return totalPerCategory.map(() => 0);
  }

  return totalPerCategory.map(value =>
    parseFloat(((value / sumTotalIncome) * 100).toFixed(2))
  );
};

export default calculatePercentIncome;
